<template>
  <v-breadcrumbs :items="items" class="px-0">
    <template v-slot:divider>
      <v-icon class="mt-2 mt-md-1">mdi-chevron-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
        :to="item.to"
        :exact="item.exact"
        :disabled="item.disabled"
        class="mt-2 mt-md-1"
      >
        <span :class="[item.disabled ? '' : 'tway-morado--text', 'text']">
          <span v-if="mobile && item.text">
            {{ item.text.length > 20 ? item.text.slice(0, 20) + '...' : item.text  }}
          </span>
          <span v-else>
            {{ item.text }}
          </span>
        </span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<style scoped>

.tway-morado--text{
  color: #7319D5;
}

.text{
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-overflow: ellipsis;
}

</style>

<script>
export default {
  name: 'Breadcrumbs',

  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    mobile () {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    }
  }
}
</script>